import { UNSET } from '../../constants';
import { IAmplitudeAttributes } from '../../types';

import { recordAmplitudeUserProperties } from './client';
import { notifyWhenAmplitudeIdentityUpdateCompletes } from './identity-update';

export const setAmplitudeUserProperties = (userProperties: IAmplitudeAttributes): void => {
  notifyWhenAmplitudeIdentityUpdateCompletes(recordAmplitudeUserProperties(userProperties, UNSET));
};
